import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import DraftModule from "./modules/DraftModule";
import SnakeDraftModule from "./modules/SnakeDraftModule";
import ContestDetails from "../details/ContestDetails";
import BackButton from "../components/general/BackButton";
import { fetchSelectedContestDetails } from "../../../utils/api";
import "./DraftPage.css";
import LoadingDraft from "../../../assets/images/loading-draft.svg";

const DraftPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [contest, setContest] = useState(null);

  useEffect(() => {
    const fetchContest = async () => {
      try {
        const contestData = await fetchSelectedContestDetails(id);
        setContest(contestData);
      } catch (error) {
        console.error("Error fetching contest details:", error);
      }
    };
    fetchContest();
  }, [id]);

  const renderDraftModule = () => {
    if (!contest) {
      return <img src={LoadingDraft} alt="Loading..." style={{ width: "50px", height: "50px" }} />;
    }

    switch (contest.draftType) {
      case 'Snake':
        return <SnakeDraftModule contest={contest} />;
      case 'Salary':
        return <DraftModule contest={contest} />;
      // Add cases for 'Algo' or other types here if needed
      default:
        return <div>Unsupported draft type: {contest.draftType}</div>;
    }
  };

  return (
    <div className="draft-page-container">
      {contest && contest.draftType !== 'Snake' && (
        <BackButton to={`/contests/registering/${id}`}>
          ◄ Return to Contest Lobby
        </BackButton>
      )}
      {contest && <ContestDetails contest={contest} showEnterButton={false} />}
      {renderDraftModule()}
    </div>
  );
};

export default DraftPage;
